import { render, staticRenderFns } from "./ModalCounting.vue?vue&type=template&id=b48539b6&scoped=true&"
import script from "./ModalCounting.vue?vue&type=script&lang=js&"
export * from "./ModalCounting.vue?vue&type=script&lang=js&"
import style0 from "./ModalCounting.vue?vue&type=style&index=0&id=b48539b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48539b6",
  null
  
)

export default component.exports